import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { GlobalLoaderService } from '../../services/global-loader.service';

/** Must match {@link UserAuthService.TOKEN_KEY} (avoid injecting UserAuthService here — HttpClient cycle). */
const LS_TOKEN_KEY = 'token';

function buildOutgoingRequest(req: HttpRequest<unknown>): {
  request: HttpRequest<unknown>;
  showLoader: boolean;
} {
  const userToken = localStorage.getItem('appbearer');
  const appToken = localStorage.getItem(LS_TOKEN_KEY);

  let bearer = '';
  
  if (userToken) bearer = userToken;
  // if (userToken) bearer = userToken;
  else if (appToken) bearer = appToken;

  const setHeaders: Record<string, string> = { Accept: 'application/json' };
  // if (bearer) setHeaders['Authorization'] = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZlcnJhbF9iZWFyZXIiOiIyN2MyZTRlMS0wMjI3LTQyM2MtODQ1MS1jMTM4M2Y4ZWVkZmMiLCJhdXRoX3VzZXIiOiJzaGFua2FyLmMrMDAxNEBjZWlwYWwuY29tIiwiaWF0IjoxNzc5MjYwMTM3LCJleHAiOjE3NzkzNDY1Mzd9.U9A8Q2l44UI1tJgsYHcrisV5IJAZIoMYGmYDZydcP6Y";
  if (bearer) setHeaders['Authorization'] = bearer;
  if (req.headers.has('ShareJobCall')) {
    setHeaders['ShareJobCall'] = 'shareJobCall';
  }

  const request = req.clone({ setHeaders });
  let showLoader = true;
  if (typeof request.body === 'string') {
    showLoader = !(request.body.indexOf('dontshowloader') > 0);
  }

  return { request, showLoader };
}

/**
 * Functional equivalent of legacy `HttpConfigInterceptor`:
 * merges user vs applicant bearer (plus v1 `token`), sets Accept / ShareJobCall,
 * toggles loader unless body string contains `dontshowloader`,
 * handles JSON `SessiontimedOut === 1` for applicant sessions.
 */
export const httpConfigInterceptor: HttpInterceptorFn = (
  req,
  next
): Observable<HttpEvent<unknown>> => {
  const platformId = inject(PLATFORM_ID);
  const loaderService = inject(GlobalLoaderService);

  if (!isPlatformBrowser(platformId)) {
    return next(req);
  }
  const applicantTokenAtStart = localStorage.getItem('appbearer');
  const { request, showLoader } = buildOutgoingRequest(req);

  if (showLoader) {
    loaderService.show();
  }

  return next(request).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        const body = event.body as Record<string, unknown> | null;
        if (
          body != null &&
          typeof body['SessiontimedOut'] !== 'undefined' &&
          body['SessiontimedOut'] === 1
        ) {
          localStorage.clear();
          window.location.href = '/login';

          // if (applicantTokenAtStart) {
          //   alert('Session timed out');
          //   // return;
          //   localStorage.clear();
          //   const path = typeof environment.loginPath === 'string' ? environment.loginPath : '/login';
          //   window.location.href = path.startsWith('http')
          //     ? path
          //     : `${window.location.origin}${path.startsWith('/') ? '' : '/'}${path}`;
          // }
        }
      }
    }),
    finalize(() => {
      if (showLoader) {
        loaderService.hide();
      }
    }),
    
  );
};
